module.exports = __webpack_public_path__ + "media/images/newyear-73e43c26bc185be6144094dde5d87cc8.jpg";